//local Env
// export const baseURL = "http://127.0.0.1:5000";

//Prod Env
export const baseURL = "https://fleetconex.com/api";

//Test Env
// export const baseURL = "https://caledontec.com/telematics_python";
